module.exports = __webpack_public_path__ + "img/question14.87fe9b88.png";